<template>
  <div class="container-fluid" dir="ltr">
    <!-- <highcharts class="hc" :options="chartOptions" ref="chart"></highcharts> -->
    <apexchart height="350" :options="ApexChartOptions" :series="ApexChartOptions.series"></apexchart>
  </div>
</template>
<script>
export default {
  data() {
    return {
      chartOptions: {
        chart: {
          type: 'bar',
        },
        series: [
          {
            data: [],
            name: 'تعداد تماس در روز',
          },
        ],
        title: {
          text: 'نمودار تماس در ماه',
        },
        xAxis: {
          title: {
            text: 'ماه',
          },
          categories: ['فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسنفد'],
          tickInterval: 1,
        },
        yAxis: {
          title: {
            text: 'تعداد تماس',
          },
        },
      },
      ApexChartOptions: {
        chart: {
          type: 'bar',
        },
        dataLabels: {
          enabled: false,
        },
        colors: ['#FDA700', '#fd397a', '#1dc9b7', '#5CB0FF', '#5578eb'],
        series: [{ type: '', data: [] }],

        stroke: {
          show: true,
          width: 0.5,
        },
        yaxis: {
          title: {
            text: 'تعداد تماس',
          },
        },
        xaxis: {
          labels: {
            rotate: -63.5,
          },

          title: {
            text: 'ماه',
          },
          categories: ['فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسنفد'],
          tickPlacement: 'on',
        },
        legend: {
          position: 'top',
          horizontalAlign: 'left',
          offsetX: 40,
        },
      },
    }
  },
  props: ['data'],
  created() {
    this.data.forEach((element, index) => {
      element.forEach((value) => {
        if (this.chartOptions.series[index]) {
          this.chartOptions.series[index].data.push(value.CallCount)
          this.chartOptions.series[index].name = value.name
          this.ApexChartOptions.series[index].data.push(value.CallCount)
          this.ApexChartOptions.series[index].name = value.name
          this.ApexChartOptions.series[index].type = 'bar'
        } else {
          this.chartOptions.series[index] = {
            data: [],
            name: value.name,
          }
          this.ApexChartOptions.series[index] = {
            data: [],
            name: value.name,
            type: 'bar',
          }
          this.ApexChartOptions.series[index].data.push(value.CallCount)
        }
      })
    })
  },
}
</script>
<style>
div.apexcharts-tooltip-title {
  font-family: 'IRANSansWeb' !important;
  color: var(--sidebar-color-item) !important;
  fill: var(--sidebar-color-item) !important;
  background: var(--sidebar-action-bg) !important;
}
div.apexcharts-tooltip-series-group {
  font-family: 'IRANSansWeb' !important;
  color: var(--sidebar-color-item) !important;
  fill: var(--sidebar-color-item) !important;
  background: var(--sidebar-action-bg) !important;
}
span.apexcharts-tooltip-text-y-label {
  font-family: 'IRANSansWeb' !important;
  color: var(--sidebar-color-item) !important;
  fill: var(--sidebar-color-item) !important;
  background: var(--sidebar-action-bg) !important;
}
</style>
